import getUrlQuery from 'get-url-query';

export default getUrlQuery();
